import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { initializeAuth } from './utils/authUtils';
import { initGoogleConsent } from './utils/googleConsent';
import { initGoogleAds } from './utils/googleAds';
import { initGoogleTagManager } from './utils/googleTagManager';
import { initPostHog } from './utils/posthog';
import { initYandexMetrika } from './utils/yandexMetrika';
import { ensureLanguagePrefix } from './config/region';

// A bare URL is sent to its /<lang>/ twin before anything renders, so no page is ever served at
// two addresses. This may navigate away, in which case nothing below runs.
ensureLanguagePrefix();

// Initialize authentication before rendering the app
initializeAuth();

// Consent Mode default for every Google tag below — must reach the dataLayer before any of them
// is configured. See utils/googleConsent.js.
initGoogleConsent();

// Google Ads tag, europe only and only once marketing consent is given. See utils/googleAds.js.
initGoogleAds();

// Google Tag Manager container, europe only and only once analytics consent is given.
// See utils/googleTagManager.js.
initGoogleTagManager();

// PostHog analytics + session replay, europe only and only once analytics consent is given.
// See utils/posthog.js.
initPostHog();

// Yandex.Metrika, europe only and only once analytics consent is given.
// See utils/yandexMetrika.js.
initYandexMetrika();

const root = document.getElementById('root');
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

createRoot(root).render(app);

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js');
}
